// extracted by mini-css-extract-plugin
module.exports = {"alignTools":"AlignTools_alignTools__1QcpI","alignGroup":"AlignTools_alignGroup__YCMp8"};